// store/settingSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import HomeService from "@/services/api/HomeService";

export const fetchGeneralSetting = createAsyncThunk(
  "settings/fetchGeneralSetting",
  async (_, { rejectWithValue }) => {
    try {
      const response = await HomeService.getSiteSetting();
      return response;
    } catch (error) {
      console.log("reudx error",error)
    }
  }
);

const settingSlice = createSlice({
  name: "setting",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGeneralSetting.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGeneralSetting.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchGeneralSetting.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default settingSlice.reducer;
